<div class="card-content">
  <div class="first-third" [style.margin-bottom.rem]="(viewModel.showPill$ | async) ? 0.5 : null">
    <div class="brand" [style.color]="viewModel.headerTextColor$ | async">
      {{ data | sectionRowViewModelBasicMethod: 'getBrand' }}
    </div>
    <div class="title-size-cannabinoids" [style.color]="viewModel.bodyTextColor$ | async">
      <div class="title-size">
        <div *ngIf="data | sectionRowViewModelBasicMethod: 'getRowTitle' as title" class="product-card-variant-title">
          {{ title }}
        </div>
        <div
          *ngIf="viewModel | getExpandedGridSize: (viewModel.spoofedColViewModel$ | async) | async | lowercase as size"
          class="product-card-size">
          {{ size }}
        </div>
      </div>
      <div class="cannabinoids">
        <div
          *ngIf="data | sectionRowViewModelBasicMethod: 'getCannabinoid' : 'THC' as thc"
          class="product-cannabinoid product-card-thc">
          {{ thc }} <span>THC</span>
        </div>
        <div
          *ngIf="data | sectionRowViewModelBasicMethod: 'getCannabinoid' : 'CBD' as cbd"
          class="product-cannabinoid product-card-cbd">
          {{ cbd }} <span>CBD</span>
        </div>
      </div>
    </div>
  </div>
  <div
    class="second-third"
    [style.color]="viewModel.bodyTextColor$ | async"
    [style.background-color]="viewModel.priceBannerBackgroundColor$ | async"
    [style.border-top-color]="viewModel.priceBannerBorderColor$ | async"
    [style.border-bottom-color]="viewModel.priceBannerBorderColor$ | async">
    <div
      *ngIf="viewModel.showPill$ | async"
      class="logo-pill"
      [style.background-color]="viewModel.priceBannerBorderColor$ | async">
      <img
        [style.filter]="(viewModel.pillWhiteLogo$ | async) ? 'invert(1)' : null"
        class="fire-and-flower-logo"
        src="/assets/images/fire-and-flower/logo.png"
        alt="logo.png" />
      <div class="pill-text" [style.color]="viewModel.pillTextColor$ | async">{{ viewModel.pillText$ | async }}</div>
    </div>
    <div [style.margin-top.rem]="(viewModel.showPill$ | async) ? 0.5 : null">
      <app-column-primary-price
        [menu]="viewModel.cardStackMenu$ | async"
        [section]="viewModel.cardStack$ | async"
        [colVm]="viewModel.spoofedColViewModel$ | async"
        [rowVm]="viewModel.cardData$ | async"
        [locConfig]="viewModel.locationConfig$ | async"
        [locationId]="viewModel.locationId$ | async"
        [productStylingVm]="viewModel"
        [specificPriceWithoutDiscounts]="viewModel.mainPriceSpecificPriceWithoutDiscounts$ | async"
        [salePriceOnly]="viewModel.isSalePriceCard$ | async"
        [finalPriceStringModifier]="viewModel.addSpaceAfterDollarSign">
      </app-column-primary-price>
    </div>
  </div>
  <div class="last-third" [style.color]="viewModel.bodyTextColor$ | async">
    <div *ngIf="viewModel.showRegularPriceAtBottom$ | async" class="regular-price">Regular Price</div>
    <div>
      <app-column-primary-price
        *ngIf="viewModel.showRegularPriceAtBottom$ | async"
        [menu]="viewModel.cardStackMenu$ | async"
        [section]="viewModel.cardStack$ | async"
        [colVm]="viewModel.spoofedColViewModel$ | async"
        [rowVm]="viewModel.cardData$ | async"
        [locConfig]="viewModel.locationConfig$ | async"
        [locationId]="viewModel.locationId$ | async"
        [productStylingVm]="viewModel"
        [specificPriceWithoutDiscounts]="viewModel.bottomPriceSpecificPriceWithoutDiscounts$ | async"
        [finalPriceStringModifier]="viewModel.addSpaceAfterDollarSign">
      </app-column-primary-price>
    </div>
  </div>
</div>
